import React from 'react';
import {useSelector} from 'react-redux';

import {MainLayout} from 'widgets/layout';
import {Profile, TelegramChats, AdditionalEmails, MaxChats, Webhooks} from 'features/profile';
import {isUserLoadingSelector, userSelector} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

const ProfilePage: React.FC = () => {
    const isLoading = useSelector(isUserLoadingSelector);
    const user = useSelector(userSelector);

    return (
        <MainLayout isLoading={isLoading}>
            {
                user
                && <Profile user={user}/>
            }
            <AdditionalEmails />
            <TelegramChats />
            {!isTranslate() && <MaxChats />}
            <Webhooks />
        </MainLayout>
    );
};

export default ProfilePage;